import React from "react";
import BarcodeReader from 'react-barcode-reader';
import {
  Modal,
  Input,
  Form,
  Select,
  Icon,
  DatePicker,
  Tabs,
  Button,
  Tag,
  Checkbox,
  Tooltip,
  Radio
} from "antd";
import {
  GUIA_REMISION_REMITENTE
} from "../../../common/types/tipoComprobanteType";

import moment from "moment";
import auth from "../../../common/utility/auth";
import global from "../../../common/utility/global";
import { PRIVADO } from "../../../common/types/modalidadTrasladoType";
import "./styles.css";
import {
  FORMAT_DAM,
  GREATER_THAN_ZERO,
} from "../../../common/types/regularExpresionType";
import { REGISTRADO } from "../../../common/types/guiaRemisionEstadoType";
import {
  VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
  IMPUESTO_SELECTIVO_CONSUMO_VENTA,
  VENTA_DECIMAL,
} from "../../../common/types/parametroType";

import DetalleProductoServicioModal from "./FormModal/DetalleProductoServicioModal";
import DetalleReferenciaModal from "./FormModal/DetalleReferenciaModal";
import DetalleVehiculoModal from "./FormModal/DetalleVehiculoModal";
import DetalleChoferModal from "./FormModal/DetalleChoferModal";
import dialog from "../../../common/utility/dialog";
import DetalleContenedorModal from "./FormModal/DetalleContenedorModal";

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.handleScan = this.handleScan.bind(this)
  }


  handleRemoverProducto = (row) => {

    var detalleProductos = this.props.form.getFieldValue("arrDetalle");
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });

    var sumaTotalPeso = this.fetchFieldValueSum(row.identifier, "arrTotalPeso", 0);

    this.props.form.setFieldsValue({
      totalPeso: sumaTotalPeso,
      detalleProductos: detalleProductosFilter
    });

    this.props.onRemoverProducto(row, this.props.form);
  };


  handleCompleteDecimals = (property, value) => {
    if (value === "" || isNaN(parseFloat(value).toFixed(3)))
      this.props.form.setFieldsValue({ [property]: "0.000" });
    else
      this.props.form.setFieldsValue({
        [property]: parseFloat(value).toFixed(3),
      });
  };

  fetchNewValue = (value, numberDecimals) => {
    if (numberDecimals === 2)
      return value === "" || isNaN(parseFloat(value).toFixed(2))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 3)
      return value === "" || isNaN(parseFloat(value).toFixed(3))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 5)
      return value === "" || isNaN(parseFloat(value).toFixed(5))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 0)
      return value === "" || isNaN(parseFloat(value).toFixed(0))
        ? 0
        : parseFloat(value);

    return 0;
  };

  handleSearchAutocompleteCliente = async (value) => {
    const result = this.props.formValues.clientes
      .filter((item) => {
        return global
          .formatSearch(`${item.nombre} - ${item.tipoDocumento}`)
          .match(global.formatSearch(value));
      })
      .slice(0, 75);
    this.props.form.setFieldsValue({ clientes: result });
  };

  handleChangeAutocompleteCliente = (a, element) => {

    this.props.form.setFieldsValue(
      {
        documentoCliente: element.props.data.numeroDocumento,
      },
      () => {
        this.props.onChange(
          "idCliente",
          element.props.data.idEntidad,
          this.props.form
        );
      }
    );
  };



  handleSearchAutocompleteTercero = async (value) => {
    const result = this.props.formValues.clientes
      .filter((item) => {
        return global
          .formatSearch(`${item.nombre} - ${item.tipoDocumento}`)
          .match(global.formatSearch(value));
      })
      .slice(0, 75);
    this.props.form.setFieldsValue({ clientes: result });
  };

  handleChangeAutocompleteTercero = (a, element) => {

    this.props.form.setFieldsValue(
      {
        documentoTercero: element.props.data.numeroDocumento,
      },
      () => {
        this.props.onChange(
          "idTercero",
          element.props.data.idEntidad,
          this.props.form
        );
      }
    );
  };

  handleChangeVehiculo = (option, element) => {
    this.props.form.setFieldsValue(
      {
        placaVehiculo: element.props.data.placa,
        marcaVehiculo: element.props.data.marca,
        modeloVehiculo: element.props.data.modelo,
        colorVehiculo: element.props.data.color,
        tuc: element.props.data.tuc,
      }
    );

    this.props.onChange(
      "idVehiculo",
      element.key,
      this.props.form
    );
  };

  handleChangeModalidadTraslado = (option) => {

    this.props.form.setFieldsValue({
      flagTransportePrivado: option.key === PRIVADO ? true : false,
      idChofer: undefined,
      idETransporte: undefined,
      idVehiculo: undefined,
      placaVehiculo: '',
      marcaVehiculo: '',
      modeloVehiculo: '',
      colorVehiculo: '',
      flagCategoria: false,
      flagProgramado: false,
      flagVehiculoVacio: false,
      flagEmbalajeVacio: false,
      vehiculosSecundarios: [],
    });

    this.props.onChange(
      "idModalidadTraslado",
      option.key,
      this.props.form
    );
  };

  handleScan(data) {

    this.props.onScanerProduct(data,
      this.props.form.setFieldsValue,
      this.props.form.getFieldValue);
  }

  handleError(err) {
    alert('error');
    console.error(err)
  }

  fetchFieldValue = (identifier, property) => {
    var result = parseFloat(
      this.props.form.getFieldValue(`${property}[${identifier}]`)
    );
    return result;
  };

  fetchFieldValueSum = (identifier, property, paramValue) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue(property));

    for (var [key, value] of Object.entries(obj)) {
      suma = suma + (key === identifier ? paramValue : parseFloat(value));
    }

    return suma;
  };


  handleSearchAutocompleteProveedor = async (value) => {
    const result = this.props.formValues.proveedores
      .filter((item) => {
        return global
          .formatSearch(`${item.nombre} - ${item.tipoDocumento}`)
          .match(global.formatSearch(value));
      })
      .slice(0, 75);
    this.props.form.setFieldsValue({ proveedores: result });
  };

  handleChangeAutocompleteProveedor = (a, element) => {

    this.props.form.setFieldsValue(
      {
        documentoProveedor: element.props.data.numeroDocumento,
      },
      () => {
        this.props.onChange(
          "idProveedor",
          element.props.data.idEntidad,
          this.props.form
        );
      }
    );
  };


  handleRemoverVehiculo = (row) => {

    var vehiculosSecundarios = this.props.form.getFieldValue("vehiculosSecundarios");
    var vehiculosSecundariosFilter = vehiculosSecundarios.filter((m) => {
      return m.identifier !== row.identifier;
    });

    this.props.form.setFieldsValue({
      vehiculosSecundarios: vehiculosSecundariosFilter
    });

    this.props.onRemoveVehiculo(row, this.props.form);
  };


  handleChangePlaca = (value, property, identifier, row) => {
    var _vehiculo = this.props.form.getFieldValue("idVehiculo") == undefined ? 0 : this.props.form.getFieldValue("idVehiculo").key;

    var _repite = false;
    if (_vehiculo == value) {
      dialog.warning("No se puede repetir el vehículo");
      _repite = true;
    }
    var detalle = {
      identifier: global.fetchUniqueCode(),
      idVehiculo: _repite ? 0 : value,
      tuc: _repite ? '' : row.props.tuc,
    }
    var arrDetalle = this.props.form.getFieldValue("vehiculosSecundarios");
    var arrDetalleFilter = arrDetalle.filter((m) => {
      return m.identifier !== identifier;
    });
    arrDetalleFilter.push(detalle);

    this.props.form.setFieldsValue({
      [`arrnombreVehiculo[${identifier}]`]: _repite ? 0 : value,
      [`arrTuc[${identifier}]`]: property == 'arrTuc' ? value : _repite ? '' : row.props.tuc,
      vehiculosSecundarios: arrDetalleFilter,

    });
  };

  handleChangeChofer = (value, row, identifier) => {

    var _chofer = this.props.form.getFieldValue("idChofer") == undefined ? 0 : this.props.form.getFieldValue("idChofer").key;

    var _repite = false;
    if (_chofer == value) {
      dialog.warning("No se puede repetir el Chofer");
      _repite = true;
    }
    var detalle = {
      identifier: global.fetchUniqueCode(),
      idChofer: _repite ? 0 : value,
      licencia: _repite ? '' : row.props.licencia,
      nombres: _repite ? '' : row.props.nombres,
    }

    var arrDetalle = this.props.form.getFieldValue("choferesSecundarios");
    var arrDetalleFilter = arrDetalle.filter((m) => {
      return m.identifier !== identifier;
    });

    arrDetalleFilter.push(detalle);

    this.props.form.setFieldsValue({
      [`idChofer[${identifier}]`]: _repite ? 0 : value,
      [`arrLicencia[${identifier}]`]: _repite ? '' : row.props.licencia,
      choferesSecundarios: arrDetalleFilter
    });
  };

  handleRemoverChofer = (row) => {

    var choferesSecundarios = this.props.form.getFieldValue("choferesSecundarios");
    var choferesSecundariosFilter = choferesSecundarios.filter((m) => {
      return m.identifier !== row.identifier;
    });

    this.props.form.setFieldsValue({
      choferesSecundarios: choferesSecundariosFilter
    });

    this.props.onRemoveChofer(row, this.props.form);
  };

  handleRemoverContenedor = (row) => {

    var contenedores = this.props.form.getFieldValue("contenedores");
    var contenedoresFilter = contenedores.filter((m) => {
      return m.identifier !== row.identifier;
    });

    this.props.form.setFieldsValue({
      contenedores: contenedoresFilter
    });

    this.props.onRemoveContenedor(row, this.props.form);
  };


  handleCalculateDetail = (index,
    identifier,
    row,
    property,
    value,
    numberDecimals
  ) => {

    var newValue = this.fetchNewValue(value, numberDecimals);
    var params = auth.user().parametros;

    const pesoVenta = auth.user().parametros.filter(m => m.abreviatura === VENTA_DECIMAL)[0].valor === "1" ? 2 : 5;
    const cantidadVenta = auth.user().parametros.filter(m => m.abreviatura === VENTA_DECIMAL)[0].valor === "1" ? 2 : 3;



    /*********** Datos por fila ********/
    var flagAfecto =
      property === "arrFlagAfecto"
        ? value
        : this.props.form.getFieldValue(`arrFlagAfecto[${identifier}]`);
    var cantidad =
      property === "arrCantidad"
        ? newValue
        : this.fetchFieldValue(identifier, "arrCantidad");
    var pesoUnitario =
      property === "arrPesoUnitario"
        ? newValue
        : this.fetchFieldValue(identifier, "arrPesoUnitario");
    var totalPeso =
      property === "arrTotalPeso"
        ? newValue
        : this.fetchFieldValue(identifier, "arrTotalPeso");
    var fechaVencimiento =
      property === "arrFechaVencimiento"
        ? value
        : this.props.form.getFieldValue(`arrFechaVencimiento[${identifier}]`);
    var numeroLote =
      property === "arrLote"
        ? value
        : this.props.form.getFieldValue(`arrLote[${identifier}]`);


    var motivo_guia = this.props.form.getFieldValue("idConcepto");
    var idUnidadMedida = 0;
    if ([6, 7].includes(motivo_guia)) {
      idUnidadMedida = property === "arridUnidadMedida" ? value : this.props.form.getFieldValue(`arridUnidadMedida[${identifier}]`).key;
    } else {

      idUnidadMedida = row.idUnidadMedida;
    }

    var dam = null;

    /*********** Calculo totales ********/

    if (property === "arrTotalPeso") {

      /*********** Calculo totales ********/
      totalPeso = parseFloat(value);

      /*********** Calculo Cantidad ********/
      pesoUnitario = cantidad == 0 ? 0 : parseFloat((totalPeso / cantidad).toFixed(5));

    } else {

      if (totalPeso > 0 && pesoUnitario == 0) {
        pesoUnitario = cantidad == 0 ? 0 : parseFloat((totalPeso / cantidad).toFixed(5));

      } else {
        totalPeso = cantidad * pesoUnitario;
      }

    }


    /*********** Arr Detalle ********/
    var detalle = {
      identifier,
      idProducto: row.idProducto,
      codigo: row.codigo,
      flagAfecto,
      pesoUnitario,
      dam,
      cantidad,
      totalPeso,
      numeroLote,
      flagConversion: row.flagConversion,
      idUnidadMedida: idUnidadMedida,
    };

    var arrDetalle = this.props.form.getFieldValue("arrDetalle");
    var arrDetalleFilter = arrDetalle.filter((m) => {
      return m.identifier !== identifier;
    });

    arrDetalleFilter.splice(index, 0, detalle);


    var _sumaTotalPeso = 0;
    arrDetalleFilter.forEach((item) => {
      _sumaTotalPeso = _sumaTotalPeso + item.totalPeso;
    });

    /*********** Calculo suma detalle ********/


    this.props.form.setFieldsValue({
      totalPeso: _sumaTotalPeso.toFixed(3),
      arrDetalle: arrDetalleFilter,
      [`arrDam[${identifier}]`]: dam,
      [`arrFechaVencimiento[${identifier}]`]: fechaVencimiento,
      //[`arrLote[${identifier}]`]: numeroLote,
      [`arrPesoUnitario[${identifier}]`]: pesoUnitario.toFixed(pesoVenta),
      [`arrCantidad[${identifier}]`]: cantidad.toFixed(cantidadVenta),
      [`arrTotalPeso[${identifier}]`]: totalPeso.toFixed(cantidadVenta)
    });

    this.props.form.setFieldsValue({
      arrDetalle: arrDetalleFilter,
    });
  };

  handleChangeNameProduct = (row) => {
    this.props.onChangeNameProduct(row);
  };


  validate_fechaMayorQue(fechaInicial, fechaFinal) {
    var valuesStart = fechaInicial.split("/");
    var valuesEnd = fechaFinal.split("/");

    // Verificamos que la fecha no sea posterior a la actual
    var dateStart = new Date(valuesStart[2], (valuesStart[1] - 1), valuesStart[0]);
    var dateEnd = new Date(valuesEnd[2], (valuesEnd[1] - 1), valuesEnd[0]);
    if (dateStart > dateEnd) {
      return 0;
    }
    return 1;
  }



  handleOk = (e) => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);
      if (!err) {

        var params = auth.user().parametros;

        var form = {
          id: values.id,
          idUsuarioRegistro: values.idUsuarioRegistro,
          idTipoComprobante: GUIA_REMISION_REMITENTE.ID,
          idCliente: values.idCliente.key,
          idGuiaRemisionEstado: REGISTRADO,
          idMoneda: 0,
          idEstablecimiento: 0,
          idProveedor: values.idProveedor == undefined ? 0 : values.idConcepto == 3 ? values.idProveedor.key : 0,
          idTercero: values.idTercero == undefined ? 0 : values.idConcepto == 6 ? values.idTercero.key : 0,
          flagDestinatario: values.flagDestinatario == undefined ? false : values.flagDestinatario,

          idChofer: values.idChofer == undefined ? 0 : values.idChofer.key,
          idTransporte: values.idETransporte == undefined ? 0 : values.idETransporte.key,
          idVehiculo: values.idVehiculo == undefined ? 0 : values.idVehiculo.key,
          idAlmacen: values.idAlmacen == undefined ? 0 : values.idAlmacen.key,
          idMotivoTraslado: values.idMotivo == undefined ? 0 : values.idMotivo.key,
          idConcepto: values.idConcepto,//idConcepto del Movimiento de Salida
          idMovimiento: values.idMovimiento,
          idModalidadTraslado: values.idModalidadTraslado == undefined ? 0 : values.idModalidadTraslado.key,
          idUbigeoOrigen: values.idDistritoPartida.key,
          idUbigeoDestino: values.idDistritoLlegada.key,
          idListaPrecio: values.idListaPrecio == undefined ? 0 : values.idListaPrecio.key,
          idVendedor: values.idVendedor == undefined ? 0 : values.idVendedor.key,
          tipoCambio: 0,
          fecha: null,
          fechaStr: values.fechaStr.format("DD/MM/YYYY"),
          fechaTraslado: null,
          fechaTrasladoStr: values.fechaTrasladoStr.format("DD/MM/YYYY"),
          fechaEntregaStr: values.fechaEntregaStr.format("DD/MM/YYYY"),
          placaVehiculo: values.placaVehiculo,
          idProyecto: values.idProyecto == null ? 0 : values.idProyecto.key,
          bultos: values.bultos == null || "" ? 0 : parseInt(values.bultos),
          modeloVehiculo: values.modeloVehiculo,
          marcaVehiculo: values.marcaVehiculo,
          colorVehiculo: values.colorVehiculo,
          serie: values.serie,
          tuc: values.tuc,
          documento: null,
          observacion: values.observacion,
          numeroContenedor: values.numeroContenedor,
          codigoPuerto: values.codigoPuerto,
          idEstablecimientoPartida: values.idEstablecimientoPartida.key,
          direccionPartida: values.direccionPartida,

          flagCategoria: values.flagCategoria,
          flagProgramado: values.flagProgramado,

          flagVehiculoVacio: values.flagVehiculoVacio == undefined ? false : values.flagVehiculoVacio,
          flagEmbalajeVacio: values.flagEmbalajeVacio == undefined ? false : values.flagEmbalajeVacio,
          giroNegocio: values.giroNegocio == undefined ? null : values.giroNegocio,
          flagEditDireccionCliente: values.flagEditDireccionCliente,
          nroTercero: values.documentoTercero == undefined ? null : values.documentoTercero,

          idEstablecimientoDestino: values.idEstablecimientoDestino == undefined ? values.idEstablecimientoDestino : values.idEstablecimientoDestino.key,
          idEstablecimientoClienteEdit: values.idEstablecimientoClienteEdit == undefined ? 0 : values.idEstablecimientoClienteEdit,
          flagEditdireccionPartida: values.flagEditdireccionPartida,
          descripcion: values.observacion == undefined ? null : values.descripcion,
          direccionLlegada: values.direccionLlegada,
          porcentajeIGV: 18,
          subTotal: values.sumaSubTotal,
          igv: values.sumaIgv,
          total: values.sumaTotal,
          totalPeso: parseFloat(values.totalPeso),
          totalPesoCarga: values.totalPesoCarga == '' ? 0 : parseFloat(values.totalPesoCarga),
          guiaRemisionDetalles: [],
          guiaRemisionReferencias: this.fetchReferencias(values),
          guiaRemisionVehiculo: values.vehiculosSecundarios,
          guiaRemisionChofer: values.choferesSecundarios,

        };

        var Jcontenedor = this.fetchContenidor(values);
        form.jsonContenedor = Jcontenedor.length > 0 ? JSON.stringify(Jcontenedor) : null;

        if (form.idMotivoTraslado == 6 || form.idMotivoTraslado == 7) {
          form.dam = values.dam;
          form.serieDam = values.serieDam;
          form.codigoDam = values.codigoDam.key;
          var format_dam = form.dam.split("-");

          if (format_dam.length != 4) {
            dialog.warning("Formato de Dam incorecto");
            return false;
          }
        }
        var count_detalles = values.arrDetalle.length;
        for (var i = 0; i < count_detalles; i++) {
          var det = values.arrDetalle[i];

          const itemDet = {
            idProducto: parseInt(det.idProducto),
            nombre: det.nombre,
            cantidad: det.cantidad,
            pesoUnitario: parseFloat(parseFloat(det.pesoUnitario).toFixed(5)),
            totalPeso: det.totalPeso,
            numeroLote: det.numeroLote,
            codigoReferencia: det.codigo,
            dam: null,
            flagAfecto: det.flagAfecto,
            identifier: det.identifier,
            flagConversion: det.flagConversion,
            idUnidadMedida: det.idUnidadMedida
          };
          if (det.nombre != '' || det.nombre != null) {
            form.guiaRemisionDetalles.push(itemDet);
          }

        }


        //Referencias-->
        if (values.idConcepto == "4") {
          if (form.idEstablecimientoPartida == form.idEstablecimientoDestino) {
            dialog.warning("Direccion Destino no puede ser igual al Origen");
            return false;
          }

        }
        if (values.codigoMotivo == "06") {
          if (values.documentoCliente == auth.user().ruc) {
            dialog.warning("Destinatario no debe ser igual al remitente");
            return false;
          }

        }

        if (!this.validate_fechaMayorQue(form.fechaStr, form.fechaTrasladoStr)) {
          dialog.warning("La fecha de traslado debe ser mayor o igual que la fecha de emision");

          return false;
        }
        if (!this.props.form.getFieldValue("flagTransportePrivado")) {
          if (!this.validate_fechaMayorQue(form.fechaStr, form.fechaEntregaStr)) {
            dialog.warning("La fecha de entrega debe ser mayor o igual que la fecha de emision");

            return false;
          }
        }
        if (values.vehiculosSecundarios.length > 0) {
          var array = values.vehiculosSecundarios;
          var _duplicado = this.searchVehiculo(array);
          if (_duplicado.length > 0) {
            dialog.warning("No se puede duplicar el vehículo secundario");
            return false;
          }

        }

        if (values.choferesSecundarios.length > 0) {
          var array = values.choferesSecundarios;
          var _duplicado = this.searchChofer(array);
          if (_duplicado.length > 0) {
            dialog.warning("No se puede duplicar el chofer secundario");
            return false;
          }

        }
        this.props.onSave(form, this.props.form);
      }
    });
  };

  searchVehiculo = (personas) => {

    const busqueda = personas.reduce((acc, persona) => {
      acc[persona.idVehiculo] = ++acc[persona.idVehiculo] || 0;
      return acc;
    }, {});

    const duplicados = personas.filter((persona) => {
      return busqueda[persona.idVehiculo];
    });


    return duplicados;
  }


  searchChofer = (personas) => {

    const busqueda = personas.reduce((acc, persona) => {
      acc[persona.idChofer] = ++acc[persona.idChofer] || 0;
      return acc;
    }, {});

    const duplicados = personas.filter((persona) => {
      return busqueda[persona.idChofer];
    });


    return duplicados;
  }
  fetchReferencias = (values) => {
    var result = [];
    var keys = [];
    var obj = Object.assign({}, values.arrTipoComprobante);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key) => {
      result.push({
        id: 0,
        idGuiaRemision: 0,
        idTipoComprobante: values.arrTipoComprobante[key].key,
        serie: values.arrSerie[key] ? values.arrSerie[key].trim() : '',
        documento: values.arrDocumento[key] ? values.arrDocumento[key].trim() : '',
        idReferencia: values.arrIdReferencia[key],
        idReferenciaOrigen: values.arrIdReferenciaOrigen[key],
      });
    });

    return result;
  };
  fetchContenidor = (values) => {
    var result = [];
    var keys = [];
    var obj = Object.assign({}, values.arrPrecinto);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key) => {
      result.push({
        identifier: global.fetchUniqueCode(),
        numero: values.arrNumero[key],
        precinto: values.arrPrecinto[key],
      });
    });

    return result;
  };

  handleEditDireccion = () => {

    var idEstablecimientoClienteEdit = this.props.form.getFieldValue("idEstablecimientoPartida").key;
    var _varios = this.props.formValues.direccionesPartidas.filter((m) => m.id === idEstablecimientoClienteEdit);

    this.props.form.setFieldsValue({
      idEstablecimientoClienteEdit: idEstablecimientoClienteEdit,
      flagEditdireccionPartida: true,
      valueEditdireccionPartida: idEstablecimientoClienteEdit,
      idEstablecimientoPartida: idEstablecimientoClienteEdit,
      direccionPartida: _varios.length > 0 ? _varios[0].nombre + " " + _varios[0].direccion : ''
    });

  };

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  render() {
    const {
      getFieldDecorator,
      setFieldsValue,
      getFieldValue,
    } = this.props.form;

    getFieldDecorator("clientes", {
      initialValue: this.props.formValues.clientes.filter((m) => {
        return m.id === this.props.formValues.idCliente;
      }),
    });

    getFieldDecorator("proveedores", {
      initialValue: this.props.formValues.proveedores.filter((m) => {
        return m.id === this.props.formValues.idProveedor;
      }),
    });

    getFieldDecorator("id", { initialValue: this.props.formValues.id });
    getFieldDecorator("idETransporte", { initialValue: this.props.formValues.idETransporte });
    getFieldDecorator("idChofer", { initialValue: this.props.formValues.idChofer });
    getFieldDecorator("flagTransportePrivado", {
      initialValue: this.props.formValues.flagTransportePrivado,
    });
    getFieldDecorator("arrDetalle", { initialValue: this.props.arrDetalle });
    getFieldDecorator("arrReferencia", { initialValue: this.props.formValues.listaComprobanteReferencia });
    getFieldDecorator("direccionPartida", {
      initialValue: this.props.formValues.direccionPartida,
    });
    getFieldDecorator("direccionDestino", {
      initialValue: this.props.formValues.direccionDestino,
    });

    getFieldDecorator("vehiculosSecundarios", { initialValue: this.props.formValues.vehiculosSecundarios });
    getFieldDecorator("choferesSecundarios", { initialValue: this.props.formValues.choferesSecundarios });
    getFieldDecorator("contenedores", { initialValue: this.props.formValues.contenedores });

    getFieldDecorator("sumaSubTotal", {
      initialValue: this.props.formValues.sumaSubTotal,
    });
    getFieldDecorator("sumaIgv", {
      initialValue: this.props.formValues.sumaIgv,
    });
    getFieldDecorator("sumaTotal", {
      initialValue: this.props.formValues.sumaTotal,
    });
    getFieldDecorator("idUsuarioRegistro", {
      initialValue: this.props.formValues.idUsuarioRegistro,
    });

    getFieldDecorator("idConcepto", {
      initialValue: this.props.formValues.idConcepto,
    });

    getFieldDecorator("idMovimiento", {
      initialValue: this.props.formValues.idMovimiento,
    });

    getFieldDecorator("flagGuiaRemisionGeneraSalidas", {
      initialValue: this.props.formValues.flagGuiaRemisionGeneraSalidas,
    });
    getFieldDecorator("flagEditdireccionPartida", {
      initialValue: false,
    });

    getFieldDecorator("idEstablecimientoClienteEdit", {
      initialValue: this.props.formValues.idEstablecimientoClienteEdit,
    });

    getFieldDecorator("valueEditdireccionPartida", {
      initialValue: 0,
    });
    getFieldDecorator("valueEditdireccionDestino", {
      initialValue: 0,
    });
    getFieldDecorator("idEstablecimientoPartida", {
      initialValue: this.props.formValues.idEstablecimientoPartida,
    });
    getFieldDecorator("idEstablecimientoDestino", {
      initialValue: this.props.formValues.idEstablecimientoDestino,
    });

    getFieldDecorator('codigoMotivo', {
      initialValue: this.props.formValues.codigoMotivo,

    });
    getFieldDecorator('flagEditCode', {
      initialValue: this.props.formValues.flagEditCode,

    });

    getFieldDecorator("flagEditDireccionCliente", {
      initialValue: false,
    });

    getFieldDecorator("flagEditDestinoCliente", {
      initialValue: false,
    });

    return (
      <Modal
        title={(<div> {this.props.formValues.id === 0 ? `Registrar Guía de Remisión` : `Modificar Guía de Remisión`}</div>)}
        visible={this.props.visible}
        style={{ top: 30 }}
        cancelText={"Cancelar"}
        okText={"Guardar"}
        onCancel={this.handleCancel}
        onOk={this.handleOk}
        width="1050px"
      >
        <BarcodeReader
          onError={this.handleError}
          onScan={this.handleScan}
        />
        <Form>
          {getFieldDecorator("id", { initialValue: this.props.formValues.id })(
            <input type="hidden" />
          )}

          {getFieldDecorator("idComprobante", {
            initialValue: this.props.formValues.idComprobante,
          })(<input type="hidden" />)}

          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="Serie / Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "40%" }}>
                    {getFieldDecorator("serie", {
                      initialValue: this.props.formValues.serie,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Input
                        placeholder="Serie"
                        autoComplete="off"
                        className="first-input"
                        disabled={true}
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "60%" }}>
                    {getFieldDecorator("documento", {
                      initialValue: this.props.formValues.documento,
                    })(
                      <Input
                        placeholder="Documento"
                        autoComplete="off"
                        className="second-input"
                        disabled={true}
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Fecha">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaStr", {
                      initialValue: moment(
                        this.props.formValues.fechaStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        allowClear={false}
                        onChange={(moment, value) =>
                          this.props.onChange(
                            "fechaStr",
                            value,
                            this.props.form
                          )
                        }
                      />
                    )}
                  </Form.Item>

                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Fecha Traslado">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaTrasladoStr", {
                      initialValue: moment(
                        this.props.formValues.fechaTrasladoStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha de traslado"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Motivo">
                {getFieldDecorator("idMotivo", {
                  initialValue: this.props.formValues.idMotivo
                    ? { key: this.props.formValues.idMotivo }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Motivo"}
                    optionFilterProp="children"
                    onChange={(option, item) => {
                      this.props.form.setFieldsValue({ idConcepto: item.props.data });
                      this.props.onChange("idConcepto", option.key, this.props.form);
                      this.props.form.setFieldsValue({
                        dam: "",
                        serieDam: "",
                        codigoDam: "",
                        codigoMotivo: item.props.codigo,
                        flagEditDestinoCliente: false,
                        idEstablecimientoDestino: undefined,

                      })
                    }}
                  >
                    {this.props.formValues.motivos.map((item) => (
                      <Option key={item.id} value={item.id} data={item.idConcepto} codigo={item.codigoSunat}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

          </div>



          {this.props.form.getFieldValue("idConcepto") == 6 ?
            <div className="row">

              <div className="col-md-8 form-group">
                <Form.Item label="¿El distinatario es el mismo remitente?">
                  {getFieldDecorator("flagDestinatario", {
                    initialValue: this.props.formValues.flagDestinatario,
                    rules: [
                      {
                        required: false,
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Radio.Group buttonStyle="solid">
                      <Radio.Button value={true}>Establecimiento de un tercero inscrito en el RUC</Radio.Button>
                      <Radio.Button disabled value={false}>Puertos y aeropuertos</Radio.Button>
                    </Radio.Group>
                  )}
                </Form.Item>
              </div>
            </div>

            : null
          }


          {this.props.form.getFieldValue("idConcepto") == 6 ?
            <div className="row">

              <div className="col-md-2 form-group">
                <Form.Item label="N° Documento">
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("documentoTercero", {
                      initialValue: this.props.formValues.documentoTercero,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                          whitespace: true,
                        },
                      ],
                    })(
                      <Search
                        placeholder="Documento"
                        className="first-input"
                        autoComplete="off"
                        loading={this.props.formValues.proveedorLoading}
                        onSearch={(value) =>
                          this.props.onBuscarProveedor(value, this.props.form)
                        }
                        maxLength={20}
                      />
                    )}
                  </Form.Item>
                </Form.Item>
              </div>

              <div className="col-md-10 form-group">
                <Form.Item label="Tercero">

                  <Form.Item style={{ width: "100%" }}>
                    <InputGroup compact style={{ marginBottom: "1px" }}>
                      {getFieldDecorator("idTercero", {
                        initialValue: this.props.formValues.idTercero
                          ? { key: this.props.formValues.idTercero }
                          : undefined,
                        rules: [
                          {
                            required: true,
                            message: "Campo obligatorio.",
                          },
                        ],
                      })(
                        <Select
                          showSearch
                          labelInValue
                          style={{
                            width: `calc(100% - 40px)`,
                            borderTopLeftRadius: "0px",
                          }}
                          placeholder={"Búsqueda de Tercero"}
                          optionFilterProp="children"
                          showArrow={false}
                          onSearch={this.handleSearchAutocompleteTercero}
                          onChange={this.handleChangeAutocompleteTercero}
                        >
                          {this.props.formValues.clientes.map((item) => (
                            <Option key={item.id} value={item.id} data={item}>
                              <Tag>{item.tipoDocumentoNombre}</Tag>
                              {`${item.nombre}`}
                            </Option>
                          ))}
                        </Select>
                      )}
                      <Button
                        className="btn-autocomplete"
                        style={{ width: "40px", fontSize: "14px" }}
                        icon={
                          this.props.form.getFieldValue("idTercero")
                            ? "close"
                            : "search"
                        }
                        onClick={() => {
                          this.props.form.setFieldsValue(
                            {
                              idTercero: undefined,
                              documentoTercero: "",
                              idEstablecimientoTercero: undefined,
                              direccionPartida: "",
                              idEstablecimientoPartida: undefined,
                            },
                            () => {
                              this.props.onChange("direcciones-clear-provv");
                            }
                          );
                        }}
                      />
                    </InputGroup>
                  </Form.Item>

                </Form.Item>
              </div>


            </div> : null
          }



          {this.props.form.getFieldValue("idConcepto") == 3 ?
            <div className="row">

              <div className="col-md-2 form-group">
                <Form.Item label="N° Documento">
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("documentoProveedor", {
                      initialValue: this.props.formValues.documentoProveedor,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                          whitespace: true,
                        },
                      ],
                    })(
                      <Search
                        placeholder="Documento"
                        className="first-input"
                        autoComplete="off"
                        loading={this.props.formValues.proveedorLoading}
                        onSearch={(value) =>
                          this.props.onBuscarProveedor(value, this.props.form)
                        }
                        maxLength={20}
                      />
                    )}
                  </Form.Item>
                </Form.Item>
              </div>

              <div className="col-md-10 form-group">
                <Form.Item label="Proveedor">

                  <Form.Item style={{ width: "100%" }}>
                    <InputGroup compact style={{ marginBottom: "1px" }}>
                      {getFieldDecorator("idProveedor", {
                        initialValue: this.props.formValues.idProveedor
                          ? { key: this.props.formValues.idProveedor }
                          : undefined,
                        rules: [
                          {
                            required: true,
                            message: "Campo obligatorio.",
                          },
                        ],
                      })(
                        <Select
                          showSearch
                          labelInValue
                          style={{
                            width: `calc(100% - 40px)`,
                            borderTopLeftRadius: "0px",
                          }}
                          placeholder={"Búsqueda de Proveedor"}
                          optionFilterProp="children"
                          showArrow={false}
                          onSearch={this.handleSearchAutocompleteProveedor}
                          onChange={this.handleChangeAutocompleteProveedor}
                        >
                          {getFieldValue("proveedores").map((item) => (
                            <Option key={item.id} value={item.id} data={item}>
                              <Tag>{item.tipoDocumentoNombre}</Tag>
                              {`${item.nombre}`}
                            </Option>
                          ))}
                        </Select>
                      )}
                      <Button
                        className="btn-autocomplete"
                        style={{ width: "40px", fontSize: "14px" }}
                        icon={
                          this.props.form.getFieldValue("idProveedor")
                            ? "close"
                            : "search"
                        }
                        onClick={() => {
                          this.props.form.setFieldsValue(
                            {
                              idProveedor: undefined,
                              documentoProveedor: "",
                              idEstablecimientoProveedor: undefined,
                              direccionPartida: "",
                              idEstablecimientoPartida: undefined,
                            },
                            () => {
                              this.props.onChange("direcciones-clear-provv");
                            }
                          );
                        }}
                      />
                    </InputGroup>
                  </Form.Item>

                </Form.Item>
              </div>


            </div> : null
          }




          <div className="row">
            <div className="col-md-2 form-group">
              <Form.Item label="N° Documento">
                <Form.Item>
                  {getFieldDecorator("documentoCliente", {
                    initialValue: this.props.formValues.documentoCliente,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                        whitespace: true,
                      },
                    ],
                  })(
                    <Search
                      placeholder="Documento"
                      className="first-input"
                      autoComplete="off"
                      loading={this.props.formValues.clienteLoading}

                      disabled={[3, 4, 5, 6].includes(this.props.form.getFieldValue("idConcepto"))}
                      onSearch={(value) =>
                        this.props.onBuscarCliente(value, this.props.form)
                      }
                      maxLength={20}
                    />
                  )}
                </Form.Item>

              </Form.Item>
            </div>

            <div className="col-md-7 form-group">
              <Form.Item label="Cliente">
                <Form.Item>
                  <InputGroup compact style={{ marginBottom: "1px" }}>
                    {getFieldDecorator("idCliente", {
                      initialValue: this.props.formValues.idCliente
                        ? { key: this.props.formValues.idCliente }
                        : undefined,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Select
                        showSearch
                        labelInValue
                        style={{
                          width: `calc(100% - 40px)`,
                          borderTopLeftRadius: "0px",
                        }}
                        placeholder={"Búsqueda de Cliente"}
                        optionFilterProp="children"
                        showArrow={false}
                        onSearch={this.handleSearchAutocompleteCliente}
                        onChange={this.handleChangeAutocompleteCliente}
                        disabled={[3, 4, 5, 6].includes(this.props.form.getFieldValue("idConcepto"))}
                      >
                        {getFieldValue("clientes").map((item) => (
                          <Option key={item.id} value={item.id} data={item}>
                            <Tag>{item.tipoDocumentoNombre}</Tag>
                            {`${item.nombre}`}
                          </Option>
                        ))}
                      </Select>
                    )}
                    <Button
                      className="btn-autocomplete"
                      style={{ width: "40px", fontSize: "14px" }}
                      icon={
                        this.props.form.getFieldValue("idCliente")
                          ? "close"
                          : "search"
                      }
                      disabled={[3, 4, 5, 6].includes(this.props.form.getFieldValue("idConcepto"))}

                      onClick={() => {
                        this.props.form.setFieldsValue(
                          {
                            idCliente: undefined,
                            documentoCliente: "",
                            direccionLlegada: "",
                            idDepartamentoLlegada: undefined,
                            idProvinciaLlegada: undefined,
                            idDistritoLlegada: undefined,
                            idEstablecimientoPartida: undefined
                          },
                          () => {
                            this.props.onChange("direcciones-clear");
                          }
                        );
                      }}
                    />
                  </InputGroup>
                </Form.Item>

              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Tipo Traslado">
                {getFieldDecorator("idModalidadTraslado", {
                  initialValue: this.props.formValues.idModalidadTraslado
                    ? { key: this.props.formValues.idModalidadTraslado }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Traslado"}
                    optionFilterProp="children"
                    onChange={this.handleChangeModalidadTraslado}
                  >
                    {this.props.formValues.traslados.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">

            <div className="col-md-6 form-group">
              <Form.Item label="Dirección Partida">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {this.props.form.getFieldValue("flagEditDireccionCliente") ? (
                      <InputGroup compact style={{ marginBottom: "1px" }}>
                        {getFieldDecorator("direccionPartida", {
                          initialValue: this.props.formValues.direccionPartida,
                        })(
                          <Input
                            style={{
                              width: `calc(100% - 40px)`,
                              borderTopLeftRadius: "0px",
                            }}
                            placeholder="Ingresar dirección"
                            autoComplete="off"
                          />
                        )}
                        <Button
                          className="btn-autocomplete"
                          style={{ width: "40px", fontSize: "14px" }}
                          icon="close"
                          onClick={() => {

                            this.props.form.setFieldsValue({
                              flagEditDireccionCliente: false,
                            });
                          }}
                        />
                      </InputGroup>
                    ) : (
                      <InputGroup compact style={{ marginBottom: "1px" }}>
                        {getFieldDecorator("idEstablecimientoPartida", {
                          initialValue: this.props.formValues
                            .idEstablecimientoPartida
                            ? {
                              key: this.props.formValues
                                .idEstablecimientoPartida,
                            }
                            : undefined,
                          rules: [
                            {
                              required: true,
                              message: "Campo obligatorio.",
                            },
                          ],
                        })(
                          <Select
                            showSearch
                            labelInValue
                            placeholder={"Seleccione Direccion"}
                            style={{
                              width: `calc(100% - 40px)`,
                              borderTopLeftRadius: "0px",
                            }}
                            onChange={(option, row) => {
                              this.props.form.setFieldsValue({
                                direccionPartida: row.props.direccion,
                              });
                              this.props.onChange("idEstablecimientoPartida", option.key, this.props.form);

                            }}
                            optionFilterProp="children"
                          >
                            {this.props.formValues.direccionesPartidas.map((item) => (
                              <Option
                                key={item.id}
                                value={item.id}
                                direccion={item.direccion}
                              >
                                {item.nombre + " - " + item.direccion}
                              </Option>
                            ))}
                          </Select>
                        )}
                        <Button
                          className="btn-autocomplete"
                          style={{ width: "40px", fontSize: "14px" }}
                          icon="edit"
                          disabled={
                            this.props.form.getFieldValue(
                              "idEstablecimientoPartida"
                            )
                              ? false
                              : true
                          }
                          onClick={() => {
                            var idEstablecimientoClienteEdit =
                              this.props.form.getFieldValue(
                                "idEstablecimientoPartida"
                              ).key;
                            this.props.form.setFieldsValue({
                              idEstablecimientoClienteEdit:
                                idEstablecimientoClienteEdit,
                              flagEditDireccionCliente: true,
                            });
                          }}
                        />
                      </InputGroup>
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>

            </div>

            <div className="col-md-2 form-group">
              <Form.Item label="Departamento">
                {getFieldDecorator("idDepartamentoPartida", {
                  initialValue: this.props.formValues.idDepartamentoPartida
                    ? { key: this.props.formValues.idDepartamentoPartida }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.form.setFieldsValue({
                        idProvinciaPartida: undefined,
                      });
                      this.props.form.setFieldsValue({
                        idDistritoPartida: undefined,
                      });
                      this.props.onChange("idDepartamentoPartida", option.key);
                    }}
                  >
                    {this.props.formValues.departamentosPartida.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-2 form-group">
              <Form.Item label="Provincia">
                {getFieldDecorator("idProvinciaPartida", {
                  initialValue: this.props.formValues.idProvinciaPartida
                    ? { key: this.props.formValues.idProvinciaPartida }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.form.setFieldsValue({
                        idDistritoPartida: undefined,
                      });
                      this.props.onChange("idProvinciaPartida", option.key);
                    }}
                  >
                    {this.props.formValues.provinciasPartida.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Distrito">
                {getFieldDecorator("idDistritoPartida", {
                  initialValue: this.props.formValues.idDistritoPartida
                    ? { key: this.props.formValues.idDistritoPartida }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.distritosPartida.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 form-group">
              <Form.Item label="Dirección Llegada">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {this.props.form.getFieldValue("flagEditDestinoCliente") || [4, 6].includes(this.props.form.getFieldValue("idConcepto")) ? (
                      <InputGroup compact style={{ marginBottom: "1px" }}>
                        {getFieldDecorator("idEstablecimientoDestino", {
                          initialValue: this.props.formValues
                            .idEstablecimientoDestino
                            ? {
                              key: this.props.formValues
                                .idEstablecimientoDestino,
                            }
                            : undefined,
                          rules: [
                            {
                              required: true,
                              message: "Campo obligatorio.",
                            },
                          ],
                        })(
                          <Select
                            showSearch
                            labelInValue
                            placeholder={"Seleccione Direccion"}
                            style={{
                              width: `calc(100% - 40px)`,
                              borderTopLeftRadius: "0px",
                            }}
                            onChange={(option, row) => {
                              this.props.form.setFieldsValue({
                                direccionLlegada: option.label,
                              });
                              this.props.onChange("idEstablecimientoDestino", option.key, this.props.form);

                            }}
                            optionFilterProp="children"
                          >
                            {this.props.formValues.direccionesLlegadas.map((item) => (
                              <Option
                                key={item.id}
                                value={item.id}
                                direccion={item.direccion}
                              >
                                {item.nombre + " - " + item.direccion}
                              </Option>
                            ))}
                          </Select>
                        )}
                        <Button
                          className="btn-autocomplete"
                          style={{ width: "40px", fontSize: "14px" }}
                          icon="edit"
                          disabled={[3].includes(this.props.form.getFieldValue("idConcepto")) ? false : true}

                          onClick={() => {
                            var idEstablecimientoDestinoEdit =
                              this.props.form.getFieldValue(
                                "idEstablecimientoDestino"
                              ).key;
                            this.props.form.setFieldsValue({
                              idEstablecimientoDestinoEdit:
                                idEstablecimientoDestinoEdit,
                              flagEditDestinoCliente: false,
                            });
                          }}
                        />
                      </InputGroup>
                    ) : (

                      <InputGroup compact style={{ marginBottom: "1px" }}>
                        {getFieldDecorator("direccionLlegada", {
                          initialValue: this.props.formValues.direccionLlegada,
                          rules: [
                            {
                              required: true,
                              message: "Campo obligatorio.",
                            },
                          ],
                        })(
                          <Input
                            style={{
                              width: `calc(100% - 40px)`,
                              borderTopLeftRadius: "0px",
                            }}
                            placeholder="Ingresar dirección"
                            autoComplete="off"
                          />
                        )}
                        <Button
                          className="btn-autocomplete"
                          style={{ width: "40px", fontSize: "14px" }}
                          disabled={[3].includes(this.props.form.getFieldValue("idConcepto")) ? false : true}
                          icon="close"
                          onClick={() => {
                            this.props.form.setFieldsValue({
                              flagEditDestinoCliente: true,
                            });
                          }}
                        />
                      </InputGroup>

                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Departamento">
                {getFieldDecorator("idDepartamentoLlegada", {
                  initialValue: this.props.formValues.idDepartamentoLlegada
                    ? { key: this.props.formValues.idDepartamentoLlegada }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                    onChange={(option) => {

                      this.props.form.setFieldsValue({
                        idProvinciaLlegada: undefined,
                      });
                      this.props.form.setFieldsValue({
                        idDistritoLlegada: undefined,
                      });
                      this.props.onChange("idDepartamentoLlegada", option.key);
                    }}
                  >
                    {this.props.formValues.departamentosLlegada.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Provincia">
                {getFieldDecorator("idProvinciaLlegada", {
                  initialValue: this.props.formValues.idProvinciaLlegada
                    ? { key: this.props.formValues.idProvinciaLlegada }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.form.setFieldsValue({
                        idDistritoLlegada: undefined,
                      });
                      this.props.onChange("idProvinciaLlegada", option.key);
                    }}
                  >
                    {this.props.formValues.provinciasLlegada.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Distrito">
                {getFieldDecorator("idDistritoLlegada", {
                  initialValue: this.props.formValues.idDistritoLlegada
                    ? { key: this.props.formValues.idDistritoLlegada }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.distritosLlegada.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">

            <div
              className="col-md-6 form-group"
              style={{
                display: !this.props.form.getFieldValue("flagTransportePrivado")
                  ? ""
                  : "none",
              }}
            >
              <Form.Item label="Empresa de Transporte">
                {getFieldDecorator("idETransporte", {
                  initialValue: this.props.formValues.idETransporte
                    ? { key: this.props.formValues.idETransporte }
                    : undefined,
                  rules: [
                    {
                      required: ["08", "09"].includes(this.props.form.getFieldValue("codigoMotivo") && !this.props.form.getFieldValue("flagTransportePrivado")),
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Empresa de Transporte"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.form.setFieldsValue({ idVehiculo: undefined });
                      this.props.onChange("idETransporte", option.key, this.props.form);
                    }}
                  >
                    {this.props.formValues.transportes.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.numeroDocumento}-{item.razonSocial}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            {!this.props.form.getFieldValue("flagTransportePrivado") ?
              <div className={"col-md-3 form-group"}>
                <Form.Item label="Nro. Reg. MTC">
                  {getFieldDecorator("mtc", {
                    initialValue: this.props.formValues.mtc,
                  })(
                    <Input
                      placeholder="MTC"
                      autoComplete="off"
                      disabled
                    />
                  )}
                </Form.Item>
              </div>
              : null}


            <div
              className="col-md-6 form-group"

            >
              <Form.Item label="Chofer">
                {getFieldDecorator("idChofer", {
                  initialValue: this.props.formValues.idChofer
                    ? { key: this.props.formValues.idChofer }
                    : undefined,
                  rules: [
                    {
                      required: this.props.form.getFieldValue(
                        "flagTransportePrivado"
                      ),
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Chofer"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.form.setFieldsValue({ idVehiculo: undefined });
                      this.props.onChange(
                        "idChofer",
                        option.key,
                        this.props.form
                      );
                    }}
                  >
                    {this.props.formValues.choferes.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.numeroDocumento}-{item.razonSocial}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-2 form-group"

            >
              <Form.Item label="Licencia">
                {getFieldDecorator("licencia", {
                  initialValue: this.props.formValues.licencia,
                })(
                  <Input
                    placeholder=" licencia"
                    autoComplete="off"
                    disabled={true}
                    className="second-input"
                  />
                )}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">

              <Form.Item label="Vehículo">
                {getFieldDecorator("idVehiculo", {
                  initialValue: this.props.formValues.idVehiculo
                    ? { key: this.props.formValues.idVehiculo }
                    : undefined,
                  rules: [
                    {
                      required: this.props.form.getFieldValue("flagTransportePrivado"),
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Vehículo"}
                    optionFilterProp="children"
                    onChange={this.handleChangeVehiculo}
                  >
                    {this.props.formValues.vehiculos.map((item) => (
                      <Option key={item.id} value={item.id} data={item}>
                        {item.placa} ({item.marca}-{item.modelo}-{item.color})
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>

            </div>

            <div className={"col-md-2 form-group"}>
              <Form.Item label="Número de TUCE">
                {getFieldDecorator("tuc", {
                  initialValue: this.props.formValues.tuc,
                })(
                  <Input
                    placeholder="TUCE"
                    autoComplete="off"
                    readOnly
                  />
                )}
              </Form.Item>
            </div>


          </div>


          {/*        <div className="row">
            <div className="col-md-4 form-group">
              <Form.Item label="Establecimiento">
                {getFieldDecorator("idEstablecimiento", {
                  initialValue: this.props.formValues.idEstablecimiento
                    ? { key: this.props.formValues.idEstablecimiento }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Establecimiento"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.form.setFieldsValue({ idAlmacen: undefined });
                      this.props.onChange(
                        "idEstablecimiento",
                        option.key,
                        this.props.form
                      );
                    }}
                  >
                    {this.props.formValues.sucursales.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-4 form-group">
              <Form.Item label="Almacén">
                {getFieldDecorator("idAlmacen", {
                  initialValue: this.props.formValues.idAlmacen
                    ? { key: this.props.formValues.idAlmacen }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Almacén"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.almacenes.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Lista Precio">
                {getFieldDecorator("idListaPrecio", {
                  initialValue: this.props.formValues.idListaPrecio
                    ? { key: this.props.formValues.idListaPrecio }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Lista de Precio"}
                    optionFilterProp="children"
                    onChange={(option) =>
                      this.props.onChange(
                        "idListaPrecio",
                        option.key,
                        this.props.form
                      )
                    }
                  >
                    {this.props.formValues.listasPrecio.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>

            </div>
          </div> */}
          <div className="row">
            <div className={[9].includes(this.props.form.getFieldValue("idConcepto")) ? "col-md-5 form-group" : "col-md-9 form-group"}>
              <Form.Item label="Observación">
                {getFieldDecorator("observacion", {
                  initialValue: this.props.formValues.observacion,
                })(
                  <Input
                    placeholder="Ingresar Observación"
                    autoComplete="off"
                  />
                )}
              </Form.Item>
            </div>

            {[9].includes(this.props.form.getFieldValue("idConcepto")) ?

              <div className="col-md-4 form-group">
                <Form.Item label="Descripción">
                  {getFieldDecorator("descripcion", {
                    initialValue: this.props.formValues.descripcion,
                    rules: [{
                      required: true,
                      message: 'Campo obligatorio.',
                    }]
                  })(
                    <Input
                      placeholder="Ingresar Descripción"
                      autoComplete="off"
                    />
                  )}
                </Form.Item>
              </div> : null
            }

            <div className="col-md-3 form-group">
              <Form.Item label="Proyecto">
                {getFieldDecorator('idProyecto', {
                  initialValue: this.props.formValues.idProyecto ?
                    { key: this.props.formValues.idProyecto } : 0
                })(
                  <Select showSearch labelInValue
                    placeholder={"Seleccione Proyecto"}
                    optionFilterProp="children"
                    disabled={this.props.formValues.isReadOnly}
                  >
                    <Option key={0} value={0}>
                      <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                    </Option>
                    {this.props.formValues.proyectos.map(item => (
                      item.estado ?
                        <Option key={item.id} value={item.id}>{item.nombre}</Option>
                        : null
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>


          </div>

          {[6, 7].includes(this.props.form.getFieldValue("idConcepto")) ?
            <div className="row">
              <div className="col-md-6 form-group">
                <Form.Item label="Documento Relacionado">
                  {getFieldDecorator('codigoDam', {
                    initialValue: this.props.formValues.codigoDam ?
                      { key: this.props.formValues.codigoDam } : "",
                    rules: [{
                      required: true,
                      message: 'Campo obligatorio.',
                    }]
                  })(
                    <Select labelInValue
                      placeholder={"Seleccione Documento"}
                      optionFilterProp="children"
                      onChange={(option) => {
                        //this.props.form.setFieldsValue({ idVehiculo: undefined });
                        this.props.onChange(
                          "codigoDam",
                          option.key,
                          this.props.form
                        );
                      }}
                    >
                      {this.props.formValues.tiposComprobante.map(item => (
                        item.codigoSunat == "50" || item.codigoSunat == "52" ?
                          <Option key={item.codigoSunat} value={item.codigoSunat}>{item.codigoSunat + "-" + item.nombre}</Option>
                          : null
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>
              <div className="col-md-3 form-group">
                <Form.Item label="Serie DAM / DS">
                  {getFieldDecorator("serieDam", {
                    initialValue: this.props.formValues.serieDam,
                    rules: [{
                      required: true,
                      message: 'Campo obligatorio.',
                    }]
                  })(
                    <Input
                      placeholder="xxxx"
                      autoComplete="off"
                      maxLength="4"
                      minLength="4"
                    />
                  )}
                </Form.Item>

              </div>


              <div className="col-md-3 form-group">
                <Tooltip title="el formato es: xxx-xxxx-xx-xxxxxx">
                  <Form.Item label="Númeración de la DAM / DS">
                    {getFieldDecorator("dam", {
                      initialValue: this.props.formValues.dam,
                      rules: [{
                        required: true,
                        message: 'Campo obligatorio.',
                      },
                      {
                        required: true,
                        pattern: new RegExp(FORMAT_DAM),
                        message: "Formato incorecto"
                      }]
                    })(
                      <Input
                        placeholder="xxx-xxxx-xx-xxxxxx"
                        autoComplete="off"
                        className="second-input"
                        maxLength="18"
                        minLength="18"
                      />
                    )}
                  </Form.Item>
                </Tooltip>
              </div>


            </div>
            : null
          }

          <div className="row">
            <div className={"col-md-3 form-group"}>
              <Form.Item label="Cantidad de Bultos">
                {getFieldDecorator("bultos", {
                  initialValue: this.props.formValues.bultos,
                })(
                  <Input
                    placeholder="Número Contenedor"
                    autoComplete="off"
                    className="second-input"
                  />
                )}
              </Form.Item>
            </div>

            <div className="col-md-2 form-group"
              style={{
                display: !this.props.form.getFieldValue("flagTransportePrivado")
                  ? ""
                  : "none",
              }}>
              <Form.Item label="Fecha Entrega">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaEntregaStr", {
                      initialValue: moment(
                        this.props.formValues.fechaEntregaStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        allowClear={false}
                        onChange={(moment, value) =>
                          this.props.onChange(
                            "fechaEntregaStr",
                            value,
                            this.props.form
                          )
                        }
                      />
                    )}
                  </Form.Item>

                </InputGroup>
              </Form.Item>
            </div>

            {this.props.formValues.flagGiroNegocio ?

              <div className="col-md-3 form-group">
                <Form.Item label="Obra">
                  {getFieldDecorator("giroNegocio", {
                    initialValue: this.props.formValues.giroNegocio,
                  })(
                    <Input placeholder="Ingresar Obra" autoComplete="off" />
                  )}
                </Form.Item>
              </div> : null
            }

            <div className={"col-md-3 form-group"}>
              <Form.Item label="Peso Bruto Total Carga (KG)">
                {getFieldDecorator("totalPesoCarga", {
                  initialValue: this.props.formValues.totalPesoCarga,
                })(
                  <Input
                    placeholder="Peso Bruto Total Carga"
                    autoComplete="off"
                    className="second-input"
                    onKeyPress={global.onKeyPressNumber}
                  />
                )}
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 form-group">
              <Tabs
                activeKey={this.props.formValues.activeKey}
                onChange={this.props.onChangeTab}
                tabBarExtraContent={
                  <div className="custom-options">

                    <Button
                      icon="plus"
                      type="primary"
                      onClick={() =>
                        this.props.onImportarCotizacion(
                          this.props.form.setFieldsValue,
                          this.props.form.getFieldValue
                        )
                      }
                    >
                      Importar Cotización
                    </Button>
                    {!this.props.formValues.flagGuiaRemisionGeneraSalidas ? (
                      <Button
                        icon="import"
                        type="primary"
                        onClick={() =>
                          this.props.onImportarComprobante(
                            this.props.form.setFieldsValue,
                            this.props.form.getFieldValue
                          )
                        }
                      >
                        Importar Factura / Boleta
                      </Button>
                    ) : null}

                    <Button
                      icon="plus"
                      type="primary"
                      onClick={() =>
                        this.props.onAgregarDetalle(
                          this.props.form.setFieldsValue,
                          this.props.form.getFieldValue
                        )
                      }
                    >
                      Agregar
                    </Button>

                  </div>
                }
              >
                <TabPane tab="Detalle de Productos" key="1">
                  <DetalleProductoServicioModal
                    dataSource={this.props.formValues.listaComprobanteDetalle}
                    onRemove={this.handleRemoverProducto}
                    onCalculateDetail={this.handleCalculateDetail}
                    onGetFieldDecorator={getFieldDecorator}
                    onGetFieldValue={getFieldValue}
                    onSetFieldsValue={setFieldsValue}
                    onChangeNameProduct={this.handleChangeNameProduct}
                    unidadesMedida={this.props.formValues.unidadesMedida}
                    motivo={this.props.form.getFieldValue("idConcepto")}
                    flagEditCode={this.props.form.getFieldValue("flagEditCode")}

                  />
                </TabPane>
                <TabPane tab="Detalle de Referencias" key="2">
                  <DetalleReferenciaModal
                    dataSource={
                      this.props.formValues.listaComprobanteReferencia
                    }
                    tiposComprobante={this.props.formValues.tiposComprobante}
                    onRemove={this.props.onRemoverReferencia}
                    onGetFieldDecorator={getFieldDecorator}
                  />
                </TabPane>

                <TabPane tab="Vehículo Sec." key="3"
                /*disabled={this.props.form.getFieldValue("idVehiculo") == undefined || !this.props.form.getFieldValue("flagTransportePrivado")}*/
                >
                  <DetalleVehiculoModal
                    dataSource={
                      this.props.form.getFieldValue("vehiculosSecundarios")
                    }
                    onRemove={this.handleRemoverVehiculo}
                    onGetFieldDecorator={getFieldDecorator}
                    onGetFieldValue={getFieldValue}
                    onSetFieldsValue={setFieldsValue}
                    onChangeVehiculo={this.handleChangePlaca}
                    idVehiculo={this.props.form.getFieldValue("idVehiculo")}
                    vehiculos={this.props.formValues.vehiculos}

                  />
                </TabPane>

                <TabPane tab="Chofer Sec." key="4" /*disabled={this.props.form.getFieldValue("idChofer") == undefined} */>
                  <DetalleChoferModal
                    dataSource={this.props.form.getFieldValue("choferesSecundarios")}
                    onChangeChofer={this.handleChangeChofer}

                    choferes={this.props.formValues.choferes}
                    onRemove={this.handleRemoverChofer}
                    onGetFieldDecorator={getFieldDecorator}
                    onGetFieldValue={getFieldValue}
                    onSetFieldsValue={setFieldsValue}
                  />
                </TabPane>

                <TabPane tab="Contenedor" key="5" >
                  <DetalleContenedorModal
                    dataSource={this.props.form.getFieldValue("contenedores")}
                    onRemove={this.handleRemoverContenedor}
                    onGetFieldDecorator={getFieldDecorator}
                    onGetFieldValue={getFieldValue}
                    onSetFieldsValue={setFieldsValue}
                  />
                </TabPane>

              </Tabs>
            </div>
          </div>

          <div className="row">
            <div className="col-md-9 form-group">
              <div className="row">

                <div className="col-md-6 form-group"  >
                  <Form.Item>

                    {getFieldDecorator("flagProgramado", {
                      initialValue: this.props.formValues.flagProgramado,
                      valuePropName: "checked",
                    })(

                      <Checkbox
                        onChange={(e) => this.props.onChange("flagProgramado", e.target.checked)}
                      >Realizar transbordo programado</Checkbox>

                    )}
                  </Form.Item>
                </div>
                <div className="col-md-6 form-group" hidden={!this.props.form.getFieldValue("flagTransportePrivado")} >
                  <Form.Item>
                    {getFieldDecorator("flagEmbalajeVacio", {
                      initialValue: this.props.formValues.flagEmbalajeVacio,
                      valuePropName: "checked",
                    })(
                      <Checkbox
                        onChange={(e) => this.props.onChange("flagEmbalajeVacio", e.target.checked)}
                      >Retorno de vehículo con envases o embalajes vacios</Checkbox>
                    )}
                  </Form.Item>
                </div>

                <div className="col-md-6 form-group">
                  <Form.Item>
                    {getFieldDecorator("flagCategoria", {
                      initialValue: this.props.formValues.flagCategoria,
                      valuePropName: "checked",
                    })(
                      <Checkbox
                        onChange={(e) => this.props.onChange("flagCategoria", e.target.checked)}
                      > Traslado en vehículos de categoría M1 o L</Checkbox>
                    )}

                  </Form.Item>
                </div>
                <div className="col-md-6 form-group" hidden={!this.props.form.getFieldValue("flagTransportePrivado")} >
                  <Form.Item>
                    {getFieldDecorator("flagVehiculoVacio", {
                      initialValue: this.props.formValues.flagVehiculoVacio,
                      valuePropName: "checked",
                    })(
                      <Checkbox
                        onChange={(e) => this.props.onChange("flagVehiculoVacio", e.target.checked)}
                      > Indicador de retorno de vehículo vacío</Checkbox>
                    )}
                  </Form.Item>
                </div>

              </div>

            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Peso Bruto Items (KG)">
                {getFieldDecorator("totalPeso", {
                  initialValue: parseFloat(this.props.formValues.totalPeso).toFixed(
                    2
                  ),
                  rules: [
                    {
                      required: true,
                      pattern: new RegExp(GREATER_THAN_ZERO),
                      message: "Campo obligatorio mayor a 0.00",
                    },
                  ],
                })(
                  <Input
                    className="text-right"
                    placeholder="Ingresar Peso Bruto Items (KG)"
                    autoComplete="off"
                    onKeyPress={global.onKeyPressDecimals}
                    disabled={true}
                    onBlur={(e) => {
                      this.props.form.setFieldsValue({
                        totalPeso: global.onBlurDecimals(e, 2),
                      });
                    }}
                  />
                )}
              </Form.Item>
            </div>
          </div>

        </Form>
      </Modal>
    );
  }
}
export default Form.create()(FormModal);
